var render, staticRenderFns
import script from "./NodalLoadLabel.vue?vue&type=script&lang=ts"
export * from "./NodalLoadLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0db4cba')) {
      api.createRecord('a0db4cba', component.options)
    } else {
      api.reload('a0db4cba', component.options)
    }
    
  }
}
component.options.__file = "src/components/Viewer/Labels/NodalLoadLabel.vue"
export default component.exports